import { baseUrl, fetchOptions, getCredentials } from './http';
import { FourOhOneError } from '../actionCreators/system';
import CustomToast from '../components/Redesing/custom-toast';

export const getNavigationStats = (organizationId?: string, system_id?: string) => {
  const { adminEmail, adminToken, systemId } = getCredentials();
  const actualSystemId = system_id ?? systemId;

  const fetchOps = fetchOptions(
    adminEmail,
    adminToken,
    Boolean(organizationId) ? '' : actualSystemId
  );

  if (!actualSystemId && !organizationId) {
    return Promise.resolve(null);
  }

  const url = new URL(`${baseUrl}/stats/navigation`);
  if (organizationId) {
    url.searchParams.set('organization_id', organizationId);
  }

  // @ts-ignore
  return fetch(url, fetchOps)
    .then((response) => response.json())
    .then((response) => {
      if (response.status === 200) {
        return response.message;
      }
      FourOhOneError(response);
      throw new Error(response.message);
    })
    .catch((e) => {
      CustomToast({
        type: 'error',
        message:
          'There was an error getting the navigation stats. Please try again later.',
      });
      return null;
    });
};
